export class CanaisComunicacaoWhatsAppTelefone {
  public phone: string;
  public amount: number;
  public lastmessageid: string;
  public guidclientenapis: string;

  constructor() { }
}
